@use "../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../styles/Constants.scss" as Constants;

.RateInputChoice {
	.title {
		font-size: Constants.$val-fontSizeBig;
		line-height: Constants.$val-lineHeightBig;
		font-weight: bold;
	}
	
	.requiredTick {
		color: Colors.$col-orange;
	}

	.radioChoiceWithInput {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	}

	.newRateRadio {
		width: 200px;
	}

	.choiceLine {
		margin-top: Constants.$val-spacing-m;
	}
}
